import { useCallback, useState } from 'react';
// the same value as the "dp_transitions_base_duration_medium2" CSS var used in the Modal animmations
const animationDuration = 240;
const useSnackbar = ({ onShow, onHide } = {}) => {
    const [snackbarState, setSnackbarState] = useState('hidden');
    const showSnackbarHandler = useCallback(() => {
        if (snackbarState === 'hidden') {
            setSnackbarState('showing');
            setTimeout(() => {
                setSnackbarState('shown');
                onShow === null || onShow === void 0 ? void 0 : onShow();
            }, animationDuration);
        }
    }, [snackbarState, onShow]);
    const hideSnackbarHandler = useCallback(() => {
        if (snackbarState === 'shown') {
            setSnackbarState('hidding');
            // wait before setting the state to hidden to give the animation time to run
            setTimeout(() => {
                setSnackbarState('hidden');
                onHide === null || onHide === void 0 ? void 0 : onHide();
            }, animationDuration);
        }
    }, [snackbarState, onHide]);
    return {
        showSnackbarHandler,
        hideSnackbarHandler,
        snackbarState,
    };
};
export default useSnackbar;
//# sourceMappingURL=index.js.map